// src/client/components/project/create-report-button.tsx
import React from 'react';
import { useParams } from 'react-router-dom';

import { useDashboardDataContext } from './dashboard/dashboard-context';

import { isAssessmentEmpty } from '~/client/helpers';
import * as GQL from '~/graphql/generated/client';
import { MedicalHeartrateReport } from '~c/components/base/icon';
import { LeftNavMenuItem } from '~c/components/base/left-nav';
import {
  aiDashboardUtils,
  functionalModelsRouteUtil,
  candidateModelsDetailsRouteUtil,
} from '~c/routes';

interface Props {
  className?: string;
}

const CreateReportButton: React.FC<Props> = ({ className }) => {
  const { projectId, functionalModelId, candidateId } = useParams();
  const { assessments } = useDashboardDataContext();
  const { navigateTo: aiNavigateTo } = aiDashboardUtils.useHelper();
  const { navigateTo: functionalNavigateTo } =
    functionalModelsRouteUtil.useHelper();
  const { navigateTo: candidateNavigateTo } =
    candidateModelsDetailsRouteUtil.useHelper();

  const assessmentEmpty = isAssessmentEmpty(assessments);

  const createReportHandler = () => {
    if (candidateId && functionalModelId) {
      return candidateNavigateTo('REPORT', {
        params: {
          projectId: projectId ?? '',
          functionalModelId,
          candidateId,
        },
      });
    } else if (functionalModelId) {
      return functionalNavigateTo('REPORT', {
        params: {
          projectId: projectId ?? '',
          functionalModelId,
        },
      });
    }

    return aiNavigateTo('REPORT', {
      params: {
        projectId: projectId ?? '',
      },
    });
  };

  return (
    <LeftNavMenuItem
      icon={MedicalHeartrateReport}
      onClick={createReportHandler}
      disabled={assessmentEmpty}
    >
      Reports
    </LeftNavMenuItem>
  );
};

export default CreateReportButton;
